export default "/assets/cc4bf5b2955147801c024b2b118f4a5c.woff2";